// extracted by mini-css-extract-plugin
module.exports = {"exceptMobile":"_1cclx0","content":"UcX6aD","column":"_2QJ2JA"};